import React from 'react'


import {API_BASE_URL} from '../../constants'
import axios from 'axios'

import ReactTable  from "react-table";
import {getToken} from '../../storage'


export default class GstList extends React.Component {


  constructor() {
    super();
    this.state = {
      data: [],
      pages: null,
      loading: true
    };
    this.fetchData = this.fetchData.bind(this);
    this.handleTrclick = this.handleTrclick.bind(this)
    this.goToCreateGst = this.goToCreateGst.bind(this)
    document.title = "Gst List"
  }

  goToCreateGst(e) {
    e.preventDefault()
    this.props.history.push("/gsts/create/")
  }

  handleTrclick(state,row, column, instance) {
    return {
      onClick : (e, handleOriginal)=>{
        this.props.history.push('/gsts/edit/'+row.original.id)
      },
      style: {
        cursor:'pointer'
      }
    }
  }



    fetchData(state, instance) {
      this.setState({ loading: true });
      let apiurl = "/list_gsts/?page=" + state.page + '&page_size='+state.pageSize;
      if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
          apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
          apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
      }
      axios({
        url: apiurl,
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then(res => {
        this.setState({
          data: res.data.gsts,
          pages: res.data.pages,
          loading: false
        });
      });
    }


    render() {
      const { data, pages, loading } = this.state;
      const columns = [
        {Header:'CGST', accessor: 'cgst',sortable:true },
        {Header:'SGST',  accessor:'sgst',sortable:true},
        {Header:'IGST',  accessor:'igst',sortable:true},
      ]
      const defaultSort=[{id: "id", desc: true}]
      return <div><section className="medium">
        <ul className="list-inline">
          <li><button onClick={this.goToCreateGst} className="btn btn-primary">Create New Gst</button></li>
        </ul>
      </section>
      <div className="row">
        <div className="col-sm-12">
          <div className="table-responsive">
            <ReactTable defaultSorted={defaultSort}
              getTrProps={this.handleTrclick}
              noDataText="No Gsts Found."
                columns={columns} manual data={data}
                pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={20} />
          </div>

        </div>
      </div>

      </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/gst/gstlist.js